import { createContext } from 'react';
const DeviceContext = createContext({});

export default DeviceContext;
